import GridMaterials from './materials/script';
// import MaterialsTable from './materials-table/script';
import GridPartners from './partners/script';
import GridParts from './parts/script';
import GridPortfolios from './portfolios/script';
import GridArticlesLoadMore from './articles/grid-articles-as-tab';

export default {
	[GridMaterials.selector]: GridMaterials,
	// [MaterialsTable.selector]: MaterialsTable,
	[GridPartners.selector]: GridPartners,
	[GridParts.selector]: GridParts,
	[GridPortfolios.selector]: GridPortfolios,
	[GridArticlesLoadMore.selector]: GridArticlesLoadMore
};
